var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    { attrs: { to: _vm.playlistLink } },
    [
      _c(
        "h4",
        { staticClass: "playlist__title mb-4 mt-0" },
        [
          _c("PlaylistTitle", {
            attrs: {
              "is-private": _vm.playlist.isPrivate,
              title: _vm.playlist.title
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("playlist-card", { attrs: { playlist: _vm.playlist } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }